import { render, staticRenderFns } from "./T1ONas.vue?vue&type=template&id=76175f34&scoped=true&"
var script = {}
import style0 from "./T1ONas.vue?vue&type=style&index=0&id=76175f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76175f34",
  null
  
)

export default component.exports